import React, { Component } from 'react';
import axios from '../../../axios-orders';
import { connect } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';

import * as actionCreator from '../../../store/actions/index';

import classes from './ContactData.module.css';

import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Modal from '../../../components/UI/Modal/Modal';
import Input from '../../../components/UI/Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';

class ContactData extends Component {
	state = {
		formIsValid: false,
		orderForm: {
			// name: {
			// 	elementType: 'input',
			// 	elementConfig: {
			// 		type: 'text',
			// 		placeholder: 'Your Name',
			// 	},
			// 	label: 'Name',
			// 	value: '',
			// 	validation: {
			// 		required: true,
			// 	},
			// 	valid: false,
			// 	touched: false,
			// 	errorMessage: 'Please enter a Valid Name (e.g - John Smith)',
			// },
			// email: {
			// 	elementType: 'input',
			// 	elementConfig: {
			// 		type: 'email',
			// 		placeholder: 'Your Email',
			// 	},
			// 	label: 'Email ID',
			// 	value: '',
			// 	validation: {
			// 		required: true,
			// 		isEmail: true,
			// 	},
			// 	valid: false,
			// 	touched: false,
			// 	errorMessage: 'Enter a Valid Email (e.g - john@example.com)',
			// },
			street: {
				elementType: 'input',
				elementConfig: {
					type: 'text',
					placeholder: 'Street',
				},
				label: 'Street',
				value: '',
				validation: {
					required: true,
				},
				valid: false,
				touched: false,
				errorMessage:
					'Enter a Valid Address (e.g - 14, Park Avenue, Los Angeles)',
			},
			zipCode: {
				elementType: 'input',
				elementConfig: {
					type: 'number',
					placeholder: 'Zip Code',
				},
				label: 'Zip Code',
				value: '',
				validation: {
					required: true,
					minLength: 5,
					maxLength: 6,
					isNumeric: true,
				},
				valid: false,
				touched: false,
				errorMessage: 'Enter a Valid ZIP Code (e.g - 201002)',
			},
			country: {
				elementType: 'input',
				elementConfig: {
					type: 'text',
					placeholder: 'Your Country',
				},
				label: 'Country',
				value: '',
				validation: {
					required: true,
				},
				valid: false,
				touched: false,
				errorMessage: 'Enter a Valid Country Name (e.g - India)',
			},
			deliveryMethod: {
				elementType: 'select',
				elementConfig: {
					options: [
						{ value: 'fastest', displayValue: 'Fastest' },
						{ value: 'medium', displayValue: 'Medium' },
						{ value: 'cheapest', displayValue: 'Cheapest' },
					],
				},
				label: 'Delivery Method',
				value: 'fastest',
				validation: {},
				valid: true,
			},
		},
	};

	componentDidMount() {
		console.log(process.env.REACT_APP_STRIPE_KEY);
		// this.stripePromise = loadStripe(
		// 	'pk_test_51I7JuODZCg2Uvlj7aLciGHllDpY4CybFeLqWseAnKVq0eOzwqMSmykv7C8vwcF23r1t1bMgdWjuirUUNlQnGc1zS00BsROlXMD'
		// );
		this.stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
	}

	orderNowHandler = (event) => {
		// event.preventDefault();
		// console.log(token);
		if (!this.state.formIsValid) return;

		const formData = {};
		for (let formEl in this.state.orderForm) {
			formData[formEl] = this.state.orderForm[formEl].value;
		}

		const order = {
			ingredients: this.props.ingredients,
			totalPrice: (+this.props.totalPrice).toFixed(2),
			address: formData,
		};
		this.props.onOrderBurgerHandler(
			this.stripePromise,
			order,
			this.props.token
		);
	};

	checkValidity(rules, elementVal) {
		if (!rules) return true;

		let isValid = true;
		const value = elementVal.trim();

		if (rules.required) {
			isValid = isValid && value !== '';
		}

		if (rules.minLength) {
			isValid =
				isValid &&
				value.length >= rules.minLength &&
				value.length <= rules.maxLength;
		}

		if (rules.isEmail) {
			const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			isValid = isValid && pattern.test(value);
		}

		if (rules.isNumeric) {
			const pattern = /^\d+$/;
			isValid = isValid && pattern.test(value);
		}

		return isValid;
	}

	formElementValueChangeHandler = (elementKey, event) => {
		const updatedValue = event.target.value;

		// Here we are not creating a deep clone
		// As there are inner object also in orderForm which will still be referencing to old object
		// And we do not mutate state in React in this way
		// const updatedOrderForm = { ...this.state.orderForm };
		// updatedOrderForm[elementKey].value = updatedValue;

		const updatedOrderForm = { ...this.state.orderForm };
		const updatedFormElement = { ...updatedOrderForm[elementKey] };
		updatedFormElement.value = updatedValue;
		updatedFormElement.valid = this.checkValidity(
			updatedFormElement.validation,
			updatedFormElement.value
		);
		updatedFormElement.touched = true;

		updatedOrderForm[elementKey] = updatedFormElement;

		let formIsValid = true;
		for (let inputElement in updatedOrderForm) {
			formIsValid = formIsValid && updatedOrderForm[inputElement].valid;
		}

		this.setState({ orderForm: updatedOrderForm, formIsValid: formIsValid });
	};

	render() {
		let orderingUI = null;
		if (this.props.loading) {
			orderingUI = (
				<Modal show>
					<Spinner />
				</Modal>
			);
		}

		const formElements = [];
		for (let e in this.state.orderForm) {
			formElements.push(
				<Input
					key={e}
					label={this.state.orderForm[e].label}
					elementType={this.state.orderForm[e].elementType}
					elementConfig={this.state.orderForm[e].elementConfig}
					value={this.state.orderForm[e].value}
					errorMessage={this.state.orderForm[e].errorMessage}
					invalid={!this.state.orderForm[e].valid}
					isTouched={this.state.orderForm[e].touched}
					changed={this.formElementValueChangeHandler.bind(this, e)}
				/>
			);
		}

		return (
			<div className={classes.ContactData}>
				{/* <form> */}
				<div className={classes.FormData}>
					<h4>Enter Your Contact Details</h4>
					{formElements}
					<Button
						clicked={this.orderNowHandler}
						buttonType="Success"
						disabled={!this.state.formIsValid}
					>
						PAY ₹{this.props.totalPrice}
					</Button>
				</div>
				{/* </form> */}
				{orderingUI}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		ingredients: state.burgerBuilder.ingredients,
		totalPrice: state.burgerBuilder.totalPrice,
		loading: state.order.loading,
		token: state.auth.token,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onOrderBurgerHandler: (stripePromise, order, token) =>
			dispatch(actionCreator.purchaseBurger(stripePromise, order, token)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withErrorHandler(ContactData, axios));
